import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { TabContent, TabPane } from "reactstrap";
import "component/accountSettings/accountSettings.scss";
import "component/facilityProfile/facilityProfile.scss";
import "component/profile/profile.scss";
import { api } from "api/Api";
import { GET_CLINICIAN_DATA } from "constants/ApiUrls";
import { useParams } from "react-router-dom";
import { RESPONSE_OK } from "constants/AppConstants";
import NavTabs from "component/common/NavTabs";
const MyConfirmShifts = React.lazy(() => import("component/myDashboard/confirmShift"));
const AdminClinicianGeneralInformation = React.lazy(() => import("./clinicianGeneralSettings"));

function AdminClinicianAccountSetting() {
  const params = useParams();
  const [user, setUser] = useState({});
  
  // ------ Navtab code start------
    const [currentActiveTab, setCurrentActiveTab] = useState("1");
    const toggle = (tab) => {
      if (currentActiveTab !== tab) setCurrentActiveTab(tab);
    };

    const tabs = [
      { id: "1", label: "General information" },
      { id: "3", label: "Shifts" },
    ];
  // ------ Navtab code end------

  useEffect(() => {
    api(GET_CLINICIAN_DATA, {}, null, {
      id: params.id,
    }).then((res) => {
      if (res.status === RESPONSE_OK) {
        setUser(res.data.data);
      }
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Purple PRN - Account Settings</title>
      </Helmet>
      <div className="account-settings-main">
        <div className="custom-container">
          <h2>Clinician Account</h2>

          <NavTabs tabs={tabs} activeTab={currentActiveTab} onToggle={toggle} />
         
          <TabContent activeTab={currentActiveTab}>
            <TabPane tabId="1">
              <AdminClinicianGeneralInformation user={user} setUser={setUser} />
            </TabPane>
            <TabPane tabId="3">
              <MyConfirmShifts  values={user}  currentActiveTab={currentActiveTab} />
            </TabPane>
          </TabContent>
        </div>
      </div>
    </>
  );
}

export default AdminClinicianAccountSetting;
